export default {"src":"/_next/static/media/disc-types.211c838f.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};